const userType = {
  1: '管理员',
  2: '品牌财务',
  3: '运营专员',
  10: '装修管理员',
  11: '装修运营专员',
  20: '供货商',
  21: '客户',
  22: '财务',
  30: '工长',
  32: '质控',
  33: '监理',
  34: '工人',
  40: '预算员',
  42: '预算管理员',
  41: '材料员',
  60: '平台管理员',
  61: '平台运营',
  62: '平台财务',
  63 :'材料员',
  65: '预算员',
  66: '预算管理员',
  99: '超级管理员',
}
const orderPropDic = {
  orderNumber: '订单编号',
  state: '订单状态',
  payStates: '支付状态',
  totalAmount: '商品总价',
  payTotalAmount: '实际付款金额',
  logisticsFee: '运费金额',
  consignee: '收货人',
  phone: '电话',
  address: '详细地址',
  tradeNo: '订单支付单号',
  outTradeNo: '支付流水号',
  refundNo: '退款单号',
  outRefundNo: '退款流水号',
  remark: '备注',
  submitPayTime: '提交支付时间',
  payTime: '支付时间',
  deliveryTime: '发货时间',
  cancelTime: '取消时间',
  cancelReason: '取消原因',
  finishTime: '完成时间'
}
const subOrderPropDic = {
  orderNumber: '订单编号',
  state: '订单状态',
  payStates: '支付状态',
  refundState: '退款状态',
  number: '产品数量',
  supplierId: '供应商ID',
  totalAmount: '商品总价',
  payTotalAmount: '实际付款金额',
  logisticsFee: '运费金额',
  consignee: '收货人',
  phone: '电话',
  address: '详细地址',
  tradeNo: '订单支付单号',
  outTradeNo: '支付流水号',
  refundNo: '退款单号',
  outRefundNo: '退款流水号',
  remark: '备注',
  submitPayTime: '提交支付时间',
  payTime: '支付时间',
  deliveryTime: '发货时间',
  delivery: '物流发货单'
}
const orderItemDic = {
  orderNumber: '订单编号',
  specType: '规格类型',
  supplierId: '供应商ID',
  categoryId: '分类ID',
  category: '分类名称',
  productId: '产品ID',
  productName: '产品名称',
  image: '图片',
  number: '商品数量',
  price: '商品单价',
  amount: '金额',
  remark: '备注',
  siteImage: '现场图片'
}
const workOrderFieldDic = {
  companyId: '装修公司',
  teamId: '装修队',
  state: '状态',
  leaderName: '工长姓名',
  leaderPhone: '工长联系电话',
  designer: '设计师',
  supervisor: '质控',
  bandId: '品牌',
  shopNo: '门牌编号',
  areaMeasure: '面积',
  contactPerson: '门店联系人',
  phone: '联系人电话',
  preStartDate: '预定启程日期',
  preCheckInDate: '预定进场日期',
  preCompleteDate: '预定完工日期',
  startDate: '实际启程日期',
  checkInDate: '实际进场日期',
  completedDate: '实际完工日期'
}
const orderStates = {
  0: '待提交',
  1: '待付款',
  2: '已付款',
  3: '待发货',
  4: '已发货',
  5: '发货中',
  6: '已签收',
  8: '已完成',
  9: '取消交易',
  10: '结束',
  11: '售后退款',
  12: '售后换货'
}
const payStates = {
  0: '未支付:default',
  1: '支付中:warning',
  2: '支付成功:success',
  3: '支付失败:error'
}
const settlAuditStates = {
  0: '未处理:default',
  1: '待处理:warning',
  2: '已确认:success',
  3: '拒绝:error'
}
const productType = {
  1: '普通',
  2: '预售',
  3: '展示'
}
const productStatus = {
  0: '待审核',
  1: '审核中',
  2: '待上架',
  3: '拒绝上架',
  4: '上架',
  5: '下架'
}
const storeAttributeDictionary = {
  id: 'id',
  status: '状态',
  type: '类型',
  userName: '用户名',
  name: '姓名',
  mobile: '手机',
  address: '门店地址',
  areaDes: '门店区域',
  areaNum: '区域编码',
  brandId: '品牌ID',
  brandName: '品牌名称',
  city: '城市',
  contact: '联系人',
  group: '门店组',
  groupId: '门店组ID',
  isOutStock: '是否断货',
  joinShopName: '加盟商',
  joinShopNum: '加盟商编码',
  province: '省',
  shopCode: '门店编号',
  shopMobile: '联系方式',
  shopName: '门店名称',
  shopState: '门店状态码',
  shopStateDes: '门店状态',
  shopType: '门店类型',
  shopTypeDes: '门店类型描述',
  firstLogin: '首次登陆'
}
const homeCountDictionary = {
  brandNum: { label: '品牌数量', color: 'rgb(45, 140, 240)' },
  productNum: { label: '产品数量', color: '#e51b5b' },
  orderOkNum: { label: '待确认订单', color: 'rgb(255, 153, 0)' },
  orderUnPayNum: { label: '待支付订单', color: 'rgb(25, 190, 107)' },
  orderShipNum: { label: '待发货订单', color: 'rgb(228, 108, 187)' },
  orderFinishNum: { label: '订单完成数量', color: 'rgb(154, 102, 228)' },
  orderCancelNum: { label: '订单取消数量', color: '#777' },
  shopNum: { label: '门店数量', color: '#e51b5b' },
  smsBalance: { label: '短信余额', color: 'rgb(255, 153, 0)' },
  shippingExpireNumber: { label: '逾期订单', color: 'rgb(255, 153, 0)' }
}
const reservationOrderState = {
  '-9': '已作废',
  '-2': '已离场',
  '-1': '退回',
  1: '待分配施工方',
  2: '待分配工长',
  3: '已派单',
  5: '已进场',
  7: '停工中',
  10: '已完工',
  12: '已线上验收',
  14: '已线下验收'
}
const workorderState = {
  '-1': '待分配工长',
  0: '未开始',
  1: '在途',
  2: '进场',
  3: '逾期进场',
  4: '停工',
  5: '完工',
  6: '逾期完工',
  7: '已离场'
}
const workProcessTyps = {
  1: '进场报备',
  2: '隐蔽工程',
  3: '停工申请',
  4: '竣工申请',
  5: '离场申请',
  6: '验收单',
  7: '客户评价'
}
const jobState = {
  1: '在职',
  2: '离职'
}
const bookingObject = {
  bookingNo: '预约单号',
  createdAt: '创建时间',
  updatedAt: '更新时间',
  shopNo: '门牌编号',
  brand: '品牌',
  provinceCityAddress: '地址',
  areaMeasure: '面积',
  contactPerson: '联系人',
  phone: '联系电话',
  startTime: '开始时间',
  designer: '设计师',
  supervisor: '质控',
  state: '状态'
}
const bands = {
  1: '蜜雪冰城',
  2: '幸运咖'
}
const scheduleTypes = {
  1: '请假',
  2: '施工',
  3: '维修'
}
const adTypes = {
  0: '图片',
  1: '代码',
  2: '文字'
}
const payMethods = {
  0: '现付',
  1: '货到付款',
  2: '预付款',
  3: '结算',
  4: '部分结算',
  5: '后付款'
}
const settlMethods = {
  0: '无结算',
  1: '货到结算',
  2: '日结',
  3: '周结'
  // 4: '月结',
  // 5: '当月结'
}
const approvalStatus = {
  0: '未提交:default',
  1: '处理中:warning',
  2: '同意:success',
  3: '拒绝:error'
}
// 工长审核状态
const foremanReviewState = [
  {
    label: '全部',
    value: ''
  },
  {
    label: '待审核',
    value: 1
  },
  {
    label: '装修公司审核通过',
    value: 2
  },
  {
    label: '装修公司审核未通过',
    value: 3
  },
  {
    label: '平台审核通过',
    value: 4
  },
  {
    label: '平台审核未通过',
    value: 5
  }
]
// 工人身份
const workerIdentity = [
  {
    label: '工长',
    value: 0
  },
  {
    label: '水电工',
    value: 1
  },
  {
    label: '木工',
    value: 2
  }
]

// 表情
const emojiMap = {
  '[微笑]': '0.png',
  '[撇嘴]': '1.png',
  '[色]': '2.png',
  '[发呆]': '3.png',
  '[得意]': '4.png',
  '[大哭]': '9.png',
  '[害羞]': '6.png',
  '[闭嘴]': '7.png',
  '[睡]': '8.png',
  '[流泪]': '5.png',
  '[尴尬]': '10.png',
  '[发怒]': '11.png',
  '[调皮]': '12.png',
  '[呲牙]': '13.png',
  '[惊讶]': '14.png',
  '[难过]': '15.png',
  '[囧]': '17.png',
  '[抓狂]': '18.png',
  '[吐]': '19.png',
  '[偷笑]': '20.png',
  '[愉快]': '21.png',
  '[白眼]': '22.png',
  '[傲慢]': '23.png',
  '[累]': '25.png',
  '[惊恐]': '26.png',
  '[流汗]': '27.png',
  '[憨笑]': '28.png',
  '[悠闲]': '29.png',
  '[奋斗]': '30.png',
  '[咒骂]': '31.png',
  '[疑问]': '32.png',
  '[嘘]': '33.png',
  '[晕]': '34.png',
  '[衰]': '36.png',
  '[骷髅]': '37.png',
  '[敲打]': '38.png',
  '[再见]': '39.png',
  '[擦汗]': '40.png',
  '[抠鼻]': '41.png',
  '[鼓掌]': '42.png',
  '[坏笑]': '44.png',
  '[左哼哼]': '45.png',
  '[右哼哼]': '46.png',
  '[哈欠]': '47.png',
  '[鄙视]': '48.png',
  '[委屈]': '49.png',
  '[快哭了]': '50.png',
  '[阴险]': '51.png',
  '[亲亲]': '52.png',
  '[可怜]': '54.png',
  '[菜刀]': '55.png',
  '[西瓜]': '56.png',
  '[啤酒]': '57.png',
  '[咖啡]': '60.png',
  '[猪头]': '62.png',
  '[玫瑰]': '63.png',
  '[凋谢]': '64.png',
  '[嘴唇]': '65.png',
  '[爱心]': '66.png',
  '[心碎]': '67.png',
  '[蛋糕]': '68.png',
  '[炸弹]': '70.gif',
  '[便便]': '71.gif',
  '[月亮]': '72.gif',
  '[太阳]': '73.gif',
  '[拥抱]': '74.gif',
  '[强]': '75.gif',
  '[弱]': '76.gif',
  '[握手]': '77.gif',
  '[胜利]': '78.gif',
  '[抱拳]': '79.gif',
  '[勾引]': '80.gif',
  '[拳头]': '81.gif',
  '[OK]': '82.gif',
  '[跳跳]': '83.gif',
  '[发抖]': '84.gif'
}
const workorderType = {
  1: '新店装修',
  2: '店铺维修'
}
// 加盟商状态
const storeStatus = {
  0: '关店',
  1: '正常',
  2: '装修中',
  3: '维修中',
}
// 加盟商审核状态
const storeApplyStatus = {
  "-1": '审核不通过',
  0: '待审核',
  1: '审核通过',
}
const afterSaleState = {
  0: '未发起售后',
  1: '申请售后',
  2: '处理中',
  3: '处理完毕',
  4: '售后已取消'
}
const refundState = {
  0: '未退款',
  1: '申请中',
  2: '退款中',
  3: '已退款',
  4: '退款失败'
}
const orderStatesb = {
  0: '待审核:warning',
  1: '待付款:warning',
  2: '已付款:warning',
  3: '待发货:error',
  4: '部分发货:error',
  5: '发货中:warning',
  6: '已签收:warning',
  8: '已完成:success',
  9: '取消交易:warning',
  10: '结束:success',
  11: '售后退款:warning',
  12: '售后换货:warning',
}
export {
  userType,
  reservationOrderState,
  homeCountDictionary,
  orderStates,
  payStates,
  productType,
  productStatus,
  storeAttributeDictionary,
  workorderState,
  workProcessTyps,
  jobState,
  bookingObject,
  bands,
  scheduleTypes,
  adTypes,
  orderPropDic,
  subOrderPropDic,
  orderItemDic,
  workOrderFieldDic,
  payMethods,
  settlMethods,
  approvalStatus,
  settlAuditStates,
  foremanReviewState,
  workerIdentity,
  emojiMap,
  workorderType,
  storeStatus,
  storeApplyStatus,
  afterSaleState,
  refundState,
  orderStatesb
}
